import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-facebook-icon',
  templateUrl: 'facebook-icon.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FacebookIconComponent {
}

